import {buildActionObject} from "../../../utils/actions_utils";
import {COOKIE_BANNER_HIDE} from "../../../values/action_types";

export const hideCookieBanner = () => buildActionObject(COOKIE_BANNER_HIDE);